<!-- Product Expanded Row Content - Following customers pattern -->
<div class="expanded-row-content">
  <!-- Quick Actions at TOP (like customers) -->
  <div class="quick-actions-section">
    <p-button
      label="View Details"
      icon="pi pi-eye"
      size="small"
      severity="secondary"
      [outlined]="true"
      [disabled]="loading"
      (onClick)="onView()"
    />
    <p-button
      label="Sync Price"
      icon="pi pi-sync"
      size="small"
      severity="secondary"
      [outlined]="true"
      [disabled]="loading"
      (onClick)="onSyncPrice()"
    />
    <p-button
      label="Sync Sale Price"
      icon="pi pi-sync"
      size="small"
      severity="secondary"
      [outlined]="true"
      [disabled]="loading"
      (onClick)="onSyncSalePrice()"
    />
    <p-button
      label="Delete"
      icon="pi pi-trash"
      size="small"
      severity="danger"
      [outlined]="true"
      [disabled]="loading"
      (onClick)="onDelete()"
    />
  </div>

  <!-- Product Information Section -->
  <div class="detail-section">
    <div class="section-header">Product Information</div>
    <dl class="detail-list">
      <div class="detail-item">
        <dt>External ID</dt>
        <dd>{{ product.ExternalId || "N/A" }}</dd>
      </div>
      <div class="detail-item">
        <dt>Availability</dt>
        <dd class="availability-value">
          @for (item of formatAvailability(product.Availability); track item) {
            <span class="availability-line">{{ item }}</span>
          }
        </dd>
      </div>
      <div class="detail-item">
        <dt>Shipping Class</dt>
        <dd>{{ product.ShippingClass || "N/A" }}</dd>
      </div>
    </dl>
  </div>

  <!-- Stock & Pricing Section -->
  <div class="detail-section">
    <div class="section-header">Stock & Pricing</div>
    <dl class="detail-list">
      <div class="detail-item">
        <dt>Price</dt>
        <dd>{{ formatPrice(product.Price) }}</dd>
      </div>
      <div class="detail-item">
        <dt>Sale Price</dt>
        <dd [class.sale-price]="product.SalePrice">
          {{ formatPrice(product.SalePrice) }}
        </dd>
      </div>
      <div class="detail-item">
        <dt>Stock Level</dt>
        <dd class="stock-level-value">
          <p-tag
            [value]="getStockText()"
            [severity]="getStockSeverity()"
            [rounded]="true"
            styleClass="text-xs"
          />
        </dd>
      </div>
    </dl>
  </div>

  <!-- Scheduled Orders Section -->
  <div class="detail-section">
    <div class="section-header">Scheduled Orders</div>
    <dl class="detail-list">
      <div class="detail-item">
        <dt>Active</dt>
        <dd class="stat-active">
          {{ product.TotalQuantityScheduledActive || 0 }}
        </dd>
      </div>
      <div class="detail-item">
        <dt>Paused</dt>
        <dd class="stat-paused">
          {{ product.TotalQuantityScheduledPaused || 0 }}
        </dd>
      </div>
      @if (product.TotalQuantityFailed) {
        <div class="detail-item">
          <dt>Failed</dt>
          <dd class="stat-failed">{{ product.TotalQuantityFailed }}</dd>
        </div>
      }
      @if (product.QuantityScheduled) {
        <div class="detail-item">
          <dt>Qty Scheduled</dt>
          <dd>{{ product.QuantityScheduled }}</dd>
        </div>
      }
    </dl>
  </div>
</div>
